<section class="MainDiv relative px-4 lg:px-6 xl:px-8 py-4 sm:py-6 md:py-12 my-0 w-full" *ngIf="newsItems.length > 0">
  <div class="flex justify-between items-center mb-3 sm:mb-6">
    <h2 class="text-2xl font-bold leading-none text-black max-md:text-xl">Blogs & Stories</h2>
    <div class="flex gap-2">
      <a class="viewAll text-base font-bold text-center text-blue-500 cursor-pointer hover:text-blue-700"
        (click)="goTo()">
        View all
      </a>
    </div>
  </div>

  <!-- Carousel Track -->
  <div class="overflow-x-auto md:overflow-hidden" #carouselContainer>
    <div class="BlogDiv flex gap-6 transition-transform duration-500 ease-in-out md:gap-3 md:[transform:translateX({{
        -currentSlide * (slideWidth + gap)
      }}px)] xl:gap-6" #carouselTrack>
      <!-- News Card (as carousel item) -->
      <article *ngFor="let newsItem of newsItems"
        class="NewsCard xl:w-[310px] flex-shrink-0 md:w-[270px] hover:transition-all duration-300 hover:shadow-lg hover:shadow-gray-300"
        (click)="handleCardClick(newsItem)">
        <figure
          class="overflow-hidden relative rounded-2xl xl:h-[300px] xl:w-[310px] mx-auto md:w-[270px] cursor-pointer">
          <img [src]="newsItem.images[0]" [alt]="newsItem?.author_name" class="Img object-cover size-full" />

          <ng-container *ngIf="newsItem?.video_path">
            <div class="absolute top-0 left-0 bg-black bg-opacity-20 size-full"></div>
            <div class="play-button-container">
              <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="play-icon" style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 88px;
                  height: 88px;
                ">
                <path
                  d="M43.9987 80.6668C64.2491 80.6668 80.6654 64.2506 80.6654 44.0002C80.6654 38.4607 79.437 33.2081 77.2377 28.5C73.5963 20.7047 67.2934 14.4019 59.498 10.7608C54.7901 8.56175 49.5378 7.3335 43.9987 7.3335C23.7483 7.3335 7.33203 23.7497 7.33203 44.0002C7.33203 49.5393 8.56028 54.7915 10.7593 59.4994C14.4005 67.2949 20.7032 73.5978 28.4986 77.2392C33.2067 79.4384 38.4592 80.6668 43.9987 80.6668Z"
                  stroke="white" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
          </ng-container>
        </figure>

        <h2 class="text-md font-medium leading-7 text-black max-md:text-lg max-sm:text-base line-clamp-1">
          {{ newsItem?.title }}
        </h2>

        <time class="text-sm font-medium leading-5 text-neutral-500 max-md:text-sm max-sm:text-xs line-clamp-2">
          {{ newsItem?.created_date | date }}
        </time>
      </article>
    </div>

    <div class="hidden md:flex justify-between items-center w-full">
      <button
        class="flex justify-center items-center w-10 h-10 rounded-lg transition-all cursor-pointer duration-[0.3s] ease-[ease] shadow-[0_4px_12px_rgba(0,0,0,0.15)] z-[1] hover:transform hover:-translate-x-2 absolute left-0 top-20 -translate-y-1/2 leftBtn"
        (click)="prevSlide()" [ngStyle]="{
          background: currentSlide === 0 ? '#ccc' : '#307FE1',
          pointerEvents: currentSlide === 0 ? 'none' : 'auto',
          opacity: currentSlide === 0 ? 0.5 : 1,
        }" aria-label="Previous slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9.70711 12.7071C9.31658 12.3166 9.31658 11.6834 9.70711 11.2929L15 6" stroke="white"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
      <button
        class="flex justify-center items-center w-10 h-10 rounded-lg transition-all cursor-pointer duration-[0.3s] ease-[ease] shadow-[0_4px_12px_rgba(0,0,0,0.15)] z-[1] hover:transform hover:translate-x-2 absolute right-0 top-20 -translate-y-1/2 rightBtn"
        (click)="nextSlide()" [ngStyle]="{
          background:
            currentSlide === totalSlides - visibleItems ? '#ccc' : '#307FE1',
          pointerEvents:
            currentSlide === totalSlides - visibleItems ? 'none' : 'auto',
          opacity: currentSlide === totalSlides - visibleItems ? 0.5 : 1,
        }" aria-label="Next slide">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 6L14.2929 11.2929C14.6834 11.6834 14.6834 12.3166 14.2929 12.7071L9 18" stroke="white"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </button>
    </div>
  </div>
</section>

<!-- Video Modal (now inlined) -->
<div *ngIf="isVideoModalOpen" class="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-3 sm:p-4"
  role="dialog" aria-modal="true" (click)="closeVideoModal()">
  <div class="relative w-full max-w-4xl" (click)="$event.stopPropagation()">
    <!-- Header: Title & Close Button -->
    <div class="flex items-center justify-between pb-3 text-white">
      <h3 class="text-base sm:text-lg font-semibold truncate pr-4">
        {{ currentVideoTitle }}
      </h3>
      <button type="button"
        class="rounded-full bg-white/20 hover:bg-white/30 p-2 text-white transition-colors cursor-pointer shrink-0"
        (click)="closeVideoModal()" aria-label="Close video">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

      <!-- Video Container with Click-to-Play/Pause -->
      <div
        class="aspect-video w-full rounded-xl overflow-hidden bg-black shadow-2xl relative cursor-pointer select-none"
        (click)="togglePlayPause()" role="button" tabindex="0"
        (keydown.space)="togglePlayPause(); $event.preventDefault()">
        <iframe *ngIf="isYouTubeVideo && safeYouTubeUrl" id="youtubeHomeVideoIframe"
          [src]="safeYouTubeUrl" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
          allowfullscreen style="border: none; width: 100%; height: 100%;"></iframe>

        <!-- Center Play/Pause indicator -->
        <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div *ngIf="!isVideoPlaying || showIndicator"
            class="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-black/60 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 shadow-xl">
            <!-- Pause Icon (when briefly flashing on pause) -->
            <svg *ngIf="isVideoPlaying" width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
              <rect x="6" y="4" width="4" height="16" rx="1" />
              <rect x="14" y="4" width="4" height="16" rx="1" />
            </svg>
            <!-- Play Icon (when video is paused) -->
            <svg *ngIf="!isVideoPlaying" width="34" height="34" viewBox="0 0 24 24" fill="currentColor" class="ml-1">
              <polygon points="5,3 19,12 5,21" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>